<div class="modal-header border-0">
  <p class="fs-20 fw-800 color-gray-950 mb-0">{{'agenda.cancel_appointment'|translate}}</p>
  <a class="clickable color-gray-400" (click)="modal.dismiss()" [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
</div>

<div class="modal-body pt-0">
  <p class="fs-normal fw-500 color-gray-500 mb-1">
    {{appointment.startsAt|date:'d MMMM, HH:mm'}} · {{appointment.student?.name}}
  </p>
  <p class="fs-normal fw-400 color-gray-400">{{'agenda.cancel_confirm'|translate}}</p>

  <form [formGroup]="fg" (ngSubmit)="onSubmit()">
    <label class="color-gray-500 fw-500 fs-normal">{{'agenda.cancel_reason'|translate}}</label>
    <textarea
      class="modal-textarea w-100" formControlName="reason"
      [placeholder]="'agenda.cancel_reason_placeholder'|translate"></textarea>

    <div class="row mt-4">
      <div class="col-6">
        <app-gray-button
          type="button" color="stroke-gray" [weight]="500" customClass="fs-normal" [text]="'buttons.give_up'|translate"
          (click)="modal.dismiss()"></app-gray-button>
      </div>
      <div class="col-6">
        <app-gray-button
          type="submit" color="red" [weight]="500" customClass="fs-normal" [isLoading]="isLoading" [disabled]="isLoading"
          [text]="'agenda.cancel_appointment'|translate"></app-gray-button>
      </div>
    </div>
  </form>
</div>
